import React, { useState } from "react";
import { useForm } from "react-hook-form";
import authHeader from "services/auth-header";
import API from "services/axios";

function PermissionsAdd({ showAddPage, refreshFunc }) {
  /*   All States Below
   ********************************************* */
  const { register, handleSubmit } = useForm();
  const [formError, setFormError] = useState({});
  // redux

  /*   All Functions Below
   ********************************************* */
  const addPermissionsData = async (formData, e) => {
    setFormError({});
    e.preventDefault();

    try {
      const { data } = await API.post(
        "/permissions",
        { data: { ...formData } },
        { headers: authHeader() }
      );
      if (data.message.type === "success") {
        refreshFunc();
        showAddPage(false);
        return;
      }
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        {/*    ADD FORM START
         ********************************************* */}
        <div className="mb-13 ms-3">
          <h3>ADD Permission</h3>
        </div>
        <form className="ps-3 pe-3" onSubmit={handleSubmit(addPermissionsData)}>
          {/* ----------  Fields  ----------- */}
          <div className="mt-3 mb-3">
            <label htmlFor="permMainModule" className="form-label">
              Main Module Name
            </label>
            <input
              className="form-control"
              type="text"
              id="permMainModule"
              required
              placeholder="Enter Main Module Name"
              {...register("permMainModule")}
            />
            {formError && formError.permMainModule && (
              <p className="text-danger">{formError.permMainModule.message}</p>
            )}
          </div>
          <div className="mt-3 mb-3">
            <label htmlFor="permGroup" className="form-label">
              Group Name
            </label>
            <input
              className="form-control"
              type="text"
              id="permGroup"
              required
              placeholder="Enter name"
              {...register("permGroup")}
            />
            {formError && formError.permGroup && (
              <p className="text-danger">{formError.permGroup.message}</p>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="permName" className="form-label">
              Perm Name
            </label>
            <input
              className="form-control"
              type="permName"
              id="permName"
              required
              placeholder="Enter perm name"
              {...register("permName")}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="permDescription" className="form-label">
              Perm Description
            </label>
            <input
              className="form-control"
              type="permDescription"
              id="permDescription"
              required
              placeholder="Enter perm description"
              {...register("permDescription")}
            />
          </div>

          <div className={`mt-4 mb-2 d-flex justify-content-end`}>
            <div>
              <button
                className="btn px-1 btn-secondary"
                type="button"
                onClick={() => {
                  showAddPage(false);
                }}
              >
                Cancel
              </button>
              <button className="btn btn-primary ms-1" type="submit">
                ADD
              </button>
            </div>
          </div>
        </form>

        {/*    ADD FORM END
         ********************************************* */}
      </div>
    </div>
  );
}

export default PermissionsAdd;
